{
  "LOGIN": {
    "TITLE": "Prihlásiť sa do kontaktného centra",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Prosím zadajte platnú e-mailovú adresu"
    },
    "PASSWORD": {
      "LABEL": "Heslo",
      "PLACEHOLDER": "Heslo"
    },
    "API": {
      "SUCCESS_MESSAGE": "Prihlásenie úspešné",
      "ERROR_MESSAGE": "Nepodarilo sa pripojiť k chatovaciemu serveru. Skúste to prosím znova.",
      "UNAUTH": "Používateľské meno alebo heslo je nesprávne. Skúste to prosím znova.",
      "ACCOUNT_DEACTIVATED": "Váš účet bol deaktivovaný. Kontaktujte prosím svojho administrátora.",
      "PASSWORD_LOGIN_DISABLED": "Prihlásenie heslom je pre váš účet zakázané. Prihláste sa prosím pomocou OAuth (napr. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Prihlásiť sa cez Google",
      "BUSINESS_ACCOUNTS_ONLY": "Na prihlásenie použite prosím svoju firemnú e-mailovú adresu",
      "NO_ACCOUNT_FOUND": "Pre vašu e-mailovú adresu sme nenašli žiadny účet."
    },
    "FORGOT_PASSWORD": "Zabudli ste heslo?",
    "CREATE_NEW_ACCOUNT": "Create new account",
    "SUBMIT": "Prihlásenie"
  }
}
